export default __webpack_public_path__ + "static/works-image5-ed35e1fd77544c3b92a5acf94fa6e4c8.jpg";